import { Map, List, fromJS } from 'immutable'
import _set from 'lodash/set'
import _get from 'lodash/get'
import _includes from 'lodash/includes'
import _map from 'lodash/map'
import _parseInt from 'lodash/parseInt'
import _isUndefined from 'lodash/isUndefined'
import _toNumber from 'lodash/toNumber'
import _toString from 'lodash/toString'
import _isArray from 'lodash/isArray'
import _max from 'lodash/max'
import _isEmpty from 'lodash/isEmpty'
import _size from 'lodash/size'
import retry from 'retry-as-promised'
import { getAuthIsLoggedIn, DEVICE } from 'services/auth'
import { emarsysSend } from 'services/emarsys'
import FingerprintJS from '@fingerprintjs/fingerprintjs-pro'
import { SET_RESOLVER_DATA } from 'services/resolver/actions'
import { SET_APP_BOOTSTRAP_PHASE } from 'services/app/actions'
import { get as getCookie } from 'cookies-js'
import {
  CREATE_SERVER_EVENT,
  SET_EVENT_LEAD,
  setEventDefault,
} from 'services/event-tracking/actions'
import { PAYMENT_PROVIDER_NAME_ZUORA } from 'services/paytrack'
import { SET_PAYTRACK_DATA_LAST_TRANSACTION } from 'services/paytrack/actions'
import { SET_USER_ACCOUNT_DATA_BILLING_SUBSCRIPTIONS_WITH_DETAILS } from 'services/user-account/actions'
import { userCreate, USER_CREATION_SOURCE_ZUORA } from 'services/user'
import {
  SET_USER_DATA_ENTITLED,
  SET_USER_PROCESSING,
  SET_USER_DATA,
  SET_USER_CREATE_PROCESSING,
  SET_USER_CREATE_DATA,
  getUserEmailAvailability,
  SET_USER_CHILD_ACCOUNT,
} from 'services/user/actions'
import { selectMostRecentEligibleEntitlement } from 'services/user/selectors'
import { removeInterstitial } from 'services/interstitial/actions'
import {
  setPlansLocalizedSelection,
  getPlansData,
  setPlansSelection,
  setPlansSelectionEligibility,
  SET_PLANS_DATA,
  SET_PLANS_SELECTION,
  SET_PLANS_SELECTION_ELIGIBILITY,
  SET_PLANS_LOCALIZED_PROCESSING,
} from 'services/plans/actions'
import { NAVIGATION_HISTORY_PUSH } from 'services/navigation/actions'
import { checkVelocity, getVelocityCheckActionLocation } from 'services/velocity-check'
import {
  updateAdyenAuthorization,
  getBaseNewRelicData,
  ADYEN_PAYMENT_RESPONSE_CODE_AUTHORIZED,
  ADYEN_PAYMENT_TYPE_PAYPAL,
} from 'services/adyen'
import {
  SET_PAYMENT_DATA,
} from 'services/payment/actions'
import {
  SET_VELOCITY_CHECK_PROCESSING,
  SET_VELOCITY_CHECK_DATA,
} from 'services/velocity-check/actions'
import {
  doAuthRenew,
  setAuthPersistentData,
  setAuthLoginSuccess,
  setAuthLoginFailed,
  SET_AUTH_LOGIN_SUCCESS,
  SET_AUTH_LOGIN_FAILED,
  AUTH_LOGIN,
  AUTH_ERROR,
} from 'services/auth/actions'
import { setFeatureTrackingDataPersistent } from 'services/feature-tracking/actions'
import { setMessageBoxVisible } from 'components/MessageBox/actions'
import {
  SERVER_EVENT_PURCHASE,
  FACEBOOK_EVENT_NAME_PURCHASE,
  FACEBOOK_EVENT_ACTION_SOURCE,
  getPurchasedPlanEventData,
  buildCheckoutEcommerceObject,
  SIGN_UP_GA4_EVENT,
  BEGIN_CHECKOUT_GA4_EVENT,
  PURCHASE_GA4_EVENT,
  PAYMENT_INFO_PAGE_GA4_EVENT,
  PAYPAL_POPUP_OPENED_GA4_EVENT,
  ACCOUNT_CONFIRM_DETAILS_GA4_EVENT,
} from 'services/event-tracking'
import { setContentImpression } from 'services/content-impressions'
import { requestAnimationFrame } from 'services/animate'
import {
  format as formatDateTime,
  getUnixTimestamp,
} from 'services/date-time'
import {
  ACCOUNT_TYPE_FMTV_GIFT,
  ACCOUNT_TYPE_FMTV_COMP,
  ACCOUNT_TYPE_ZUORA_GIFT,
  USER_ACCOUNT_UNENTITLED,
} from 'services/user-account'
import {
  planIsGift,
  PLAN_ID_LIVE,
  USER_REQUIRED,
} from 'services/plans'
import {
  getUserEntitled,
  isEntitled,
} from 'services/subscription'
import { EN } from 'services/languages/constants'
import {
  CHECKOUT_STEP_ONE,
  CHECKOUT_STEP_TWO,
  CHECKOUT_STEP_THREE,
  CHECKOUT_EVENT_STEP_ONE,
  CHECKOUT_EVENT_STEP_TWO,
  CHECKOUT_EVENT_STEP_THREE,
  CHECKOUT_EVENT_STEP_FOUR,
  CHECKOUT_EVENT_STEP_FIVE,
  CHECKOUT_EVENT_STEP_SIX,
  CHECKOUT_EVENT_STEP_SEVEN,
  CHECKOUT_ORDER_ERROR_TYPE_UNKNOWN,
  CHECKOUT_ASYNC_DELAY_MILLISECONDS,
  CHECKOUT_ASYNC_MAX_ATTEMPTS,
  userCheckoutAllowed,
  getCheckoutOrderData,
  userCheckoutAccountChangePlanAllowed,
  formatCheckoutOrderMarketingValue,
} from 'services/checkout'
import {
  isCart,
  isPlans,
  isCartAccessDenied,
  isGo,
  isLogout,
  isCartConfirmation,
  isGetStarted,
  isGift as isGiftPage,
  isSinglePageCheckout,
  isSharePage,
  isPolicy,
  isCartAccountCreationCreate,
  isPlaylistPage,
  isVideoOrSeries,
} from 'services/url'
import {
  URL_PLAN_SELECTION,
  URL_PLAN_SELECTION_PLANS,
  URL_ACCOUNT_CREATION,
  URL_CART_ACCOUNT_CREATION_CREATE,
  URL_CART_BILLING,
  URL_CART_BILLING_PAYMENT,
  URL_CART_CONFIRMATION,
  URL_CART_ACCESS_DENIED,
  URL_HOME,
  URL_GAIA_PROD,
  URL_ACCOUNT_CHANGE_PLAN,
  URL_REMOTE_ACCOUNT_CREATE,
  URL_CHECKOUT,
} from 'services/url/constants'
import {
  SET_DIALOG_COMPONENT_NAME,
  SET_DIALOG_OPTIONS,
  renderModal,
} from 'services/dialog/actions'
import { GIFT_SUBSCRIPTION_STATE } from 'services/gift'
import { TYPE_LOGIN, TYPE_CART_ABANDON, TYPE_MODAL_PLAN_ACCESS } from 'services/dialog'
import { LTM, USD } from 'services/currency'
import { getPrimary } from 'services/languages'
import { addNewRelicAction } from 'services/app/_newrelic'
import { get as getConfig } from 'config'
import {
  EMAIL_PREFERENCE_FREE_ONLINE,
  EMAIL_PREFERENCE_GAIA_SPHERE,
  EMAIL_PREFERENCE_MARKETPLACE,
  EMAIL_PREFERENCE_NEWSLETTER,
  postBrooklyn as postEmailCapture,
} from 'services/email-signup'
import { NAV_TOUR_STATUS_HAS_SEEN } from 'services/feature-tracking'
import { SET_ADYEN_DROP_IN_READY } from 'services/adyen/actions'
import { ROLE_ID_AMBASSADOR } from 'services/auth-access'
import { getRemoteLoginCodeApproval } from 'services/remote-login-code/actions'
import { sendOptimizelyFeatureEvent } from 'services/optimizely-feature/actions'
import {
  setSessionStorage,
  getSessionStorage,
  clearSessionStorage,
  SESSION_STORAGE_GAIA_PLAN_SELECTION,
} from 'services/local-preferences'
import {
  client as apolloClient,
  APOLLO_CLIENT_ERROR_POLICY_ALL,
  APOLLO_CLIENT_FETCH_POLICY_NETWORK_ONLY,
} from 'services/apollo-graphql'
import { GET_PLANS_BY_SKU } from 'services/plans/query'
import fetchPlanEligibility from 'services/plans/fetchPlanEligibility'
import {
  formatBillingPlans,
  BILLING_PLAN_GRID_LOCATION_CHECKOUT,
} from 'services/plans/utils'
import * as actions from './actions'

const dateFormatString = 'YYYY-MM-DD'

const config = getConfig()
const fingerprintJsApiKey = _get(config, 'fingerPrintJsApiKey')
const fingerprintJsSubdomain = _get(config, 'fingerPrintJsSubdomain')
const velocityCheckActive = !!_get(config, ['features', 'checkout', 'velocityCheck'])
const planGraphQLActive = !!_get(config, ['features', 'checkout', 'planGraphQL'])
const purchaseOnlyUserFlowActive = !!_get(config, ['features', 'purchaseOnlyUserFlow'])
const eligibilityCheckActive = !!_get(config, ['features', 'checkout', 'eligibilityCheck'])
const cashAppBinNumbers = _get(config, ['features', 'checkout', 'cashAppBinNumbers'])

function isCheckoutPage ({ state }) {
  const { resolver } = state
  const path = resolver.getIn(['data', 'path'])
  const singlePageCheckout = isSingleCheckoutPage(path)

  return (
    isCart(path) || isPlans(path) || singlePageCheckout
  )
}

function isCheckoutFlow ({ state }) {
  const { resolver } = state
  const path = resolver.getIn(['data', 'path'])
  const singlePageCheckout = isSingleCheckoutPage(path)

  return (
    (isCart(path)
      || isPlans(path)
      || isGo(path)
      || singlePageCheckout
    )
    && !planGraphQLActive
  )
}

function isGraphQLCheckoutFlow ({ state }) {
  const { resolver } = state
  const path = resolver.getIn(['data', 'path'])
  const singlePageCheckout = isSingleCheckoutPage(path)

  return (
    (isCart(path)
      || isPlans(path)
      || isGo(path)
      || singlePageCheckout
    )
    && planGraphQLActive
  )
}

function isCartAccessDeniedPage ({ state }) {
  const { resolver } = state
  const path = resolver.getIn(['data', 'path'])

  return (
    isCartAccessDenied(path)
  )
}

function isAuthenticatedCheckout ({ state }) {
  const { resolver, auth } = state
  const path = resolver.getIn(['data', 'path'])
  const singlePageCheckout = isSingleCheckoutPage(path)

  return (
    (isPlans(path)
    || path === URL_ACCOUNT_CREATION
    || path === URL_CART_ACCOUNT_CREATION_CREATE
    || path === URL_CART_BILLING
    || path === URL_CART_BILLING_PAYMENT
    || singlePageCheckout)
    && auth.get('jwt')
  )
}

function isAnonymousCheckout ({ state }) {
  const { resolver, auth } = state
  const path = resolver.getIn(['data', 'path'])
  const singlePageCheckout = isSingleCheckoutPage(path)

  return (
    (isPlans(path)
    || path === URL_ACCOUNT_CREATION
    || path === URL_CART_ACCOUNT_CREATION_CREATE
    || path === URL_CART_BILLING
    || path === URL_CART_BILLING_PAYMENT
    || singlePageCheckout)
    && !auth.get('jwt')
  )
}

function isAccountCreatePage ({ state }) {
  const { resolver } = state
  const path = resolver.getIn(['data', 'path'])
  const singlePageCheckout = isSingleCheckoutPage(path)

  return (
    path === URL_CART_ACCOUNT_CREATION_CREATE
      || path === URL_REMOTE_ACCOUNT_CREATE
      || singlePageCheckout
  )
}

function isRemoteAccountCreatePage ({ state }) {
  const { resolver } = state
  const path = resolver.getIn(['data', 'path'])

  return (
    path === URL_REMOTE_ACCOUNT_CREATE
  )
}

function isCartPaymentPage ({ state }) {
  const { resolver } = state
  const path = resolver.getIn(['data', 'path'])
  const singlePageCheckout = isSingleCheckoutPage(path)

  return (
    path === URL_CART_BILLING_PAYMENT
    || singlePageCheckout
  )
}

function isCartConfirmationPage ({ state }) {
  const { resolver } = state
  const path = resolver.getIn(['data', 'path'])

  return (
    path === URL_CART_CONFIRMATION
  )
}

function isSingleCheckoutPage (path) {
  return isSinglePageCheckout(path)
    && !!getConfig().features.singlePageCheckout
}

function renderCartAbandon ({ state }) {
  const { resolver } = state
  const path = resolver.getIn(['data', 'path'])

  return (
    !isCart(path)
    && !isPlans(path)
    && !isGo(path)
    && !isLogout(path)
    && !isGetStarted(path)
    && !isGiftPage(path)
    && path !== '/dev/adyen' // adyen-test-page
    && path !== URL_REMOTE_ACCOUNT_CREATE
    && !isSharePage(path)
  )
}

function shouldOverrideStartDate (props) {
  const {
    user, plans, userAccount, auth,
  } = props
  const creationSource = (user.getIn(['data', 'creation_source']))
  const userIsEntitled = isEntitled(auth.get('subscriptions', List()))
  const productRatePlanId = plans.getIn(['selection', 'id'])
  const zuoraAccount = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'billingAccountId'])

  if (
    ((creationSource === ACCOUNT_TYPE_FMTV_GIFT
      || creationSource === ACCOUNT_TYPE_FMTV_COMP
      || creationSource === ACCOUNT_TYPE_ZUORA_GIFT)
    && userIsEntitled
    && !zuoraAccount
    && productRatePlanId !== PLAN_ID_LIVE)
    // this accounts for users in a gift period that *also* have a zuora account, either bc they
    // bought a gift for someone else or they were in a cancelled state and previously had
    // a billingAccountId
    || userAccount.getIn(['details', 'data', 'gift', 'status']) === GIFT_SUBSCRIPTION_STATE.ACTIVE
  ) {
    return true
  }
  return false
}

function onAuthRenewSuccess (options, dispatch) {
  const {
    auth,
    inboundTracking = Map(),
  } = options

  if (
    inboundTracking.getIn(['data', 'ci_id'])
    || inboundTracking.getIn(['data', 'ci_type'])
  ) {
    setContentImpression({
      auth: _get(auth, 'jwt'),
      timestamp: new Date(),
      contentId: inboundTracking.getIn(['data', 'ci_id']),
      contentType: inboundTracking.getIn(['data', 'ci_type']),
    })
  }

  dispatch(actions.setCheckoutOrderProcessing(false))
  dispatch(actions.setCheckoutOrderComplete(true))
}

/**
 * Handle the auth login response and set any additional user data
 */
async function onAuthLoginFeatureTracking (options = {}) {
  const { auth, user } = options
  const userLanguages = user.getIn(['data', 'language'], List())
  if (userLanguages.size > 0) {
    // No matter what happens with Feature tracking resolve with auth
    try {
      await setFeatureTrackingDataPersistent({
        auth: fromJS(auth),
        data: Map({ userLanguages }),
      })
    } catch (e) {
      // Do nothing
    }
  }
}

function getCheckoutStep (state) {
  const { resolver, plans, checkout } = state
  const path = resolver.getIn(['data', 'path'])
  const selection = plans.get('selection', Map())
  const singlePageCheckoutStep = checkout.getIn(['singlePageCheckoutStep', 'step']) || CHECKOUT_STEP_ONE
  let step

  switch (path) {
    case URL_ACCOUNT_CREATION:
    case URL_CART_ACCOUNT_CREATION_CREATE:
      step = selection.size === 0 ? CHECKOUT_STEP_ONE : CHECKOUT_STEP_TWO
      break
    case URL_PLAN_SELECTION:
    case URL_PLAN_SELECTION_PLANS:
      step = CHECKOUT_STEP_TWO
      break
    case URL_CART_BILLING:
    case URL_CART_BILLING_PAYMENT:
      step = CHECKOUT_STEP_THREE
      break
    case URL_CHECKOUT:
      step = singlePageCheckoutStep
      break
    default:
      // do nothing
  }

  return step
}

function getCheckoutEventStep (state) {
  const { resolver, checkout } = state
  const path = resolver.getIn(['data', 'path'])
  const singlePageCheckoutEventStep = checkout.getIn(['singlePageCheckoutStep', 'eventStep']) || CHECKOUT_EVENT_STEP_TWO
  let step

  switch (path) {
    case URL_ACCOUNT_CREATION:
      step = CHECKOUT_EVENT_STEP_ONE
      break
    case URL_CART_ACCOUNT_CREATION_CREATE:
      step = CHECKOUT_EVENT_STEP_TWO
      break
    case URL_PLAN_SELECTION:
      step = CHECKOUT_EVENT_STEP_THREE
      break
    case URL_PLAN_SELECTION_PLANS:
      step = CHECKOUT_EVENT_STEP_FOUR
      break
    case URL_CART_BILLING:
      step = CHECKOUT_EVENT_STEP_FIVE
      break
    case URL_CART_BILLING_PAYMENT:
      step = CHECKOUT_EVENT_STEP_SIX
      break
    case URL_CART_CONFIRMATION:
      step = CHECKOUT_EVENT_STEP_SEVEN
      break
    case URL_CHECKOUT:
      step = singlePageCheckoutEventStep
      break
    default:
      // do nothing
  }

  return step
}

// -----------------------------------
// Watcher for checking data "server side" for setting the step and event step
// -----------------------------------
export function onCheckoutStepHydrationComplete ({ after }) {
  return after(SET_APP_BOOTSTRAP_PHASE, async ({ dispatch, state }) => {
    const { app, checkout } = state
    const previousStep = checkout.get('step')
    const previousEventStep = checkout.get('eventStep')
    const step = getCheckoutStep(state)
    const eventStep = getCheckoutEventStep(state)

    // set the checkout step
    if (app.get('bootstrapComplete') && step && step !== previousStep) {
      dispatch({
        type: actions.SET_CHECKOUT_STEP,
        payload: step,
      })

      // Send emarsys "go" command
      emarsysSend()
    }

    // set the checkout step event
    if (eventStep && eventStep !== previousEventStep) {
      dispatch({
        type: actions.SET_CHECKOUT_EVENT_STEP,
        payload: eventStep,
      })
    }
  })
    .when(isCheckoutPage)
}

// -----------------------------------
// Watcher for componentDidMount/DidUpdate for setting the step and event step
// -----------------------------------
export function onCheckoutStepMountAndUpdate ({ after }) {
  return after([
    SET_RESOLVER_DATA,
    actions.SET_CHECKOUT_SINGLE_PAGE_STEP,
  ], async ({ dispatch, state }) => {
    const { checkout } = state
    const previousStep = checkout.get('step')
    const previousEventStep = checkout.get('eventStep')
    const step = getCheckoutStep(state)
    const eventStep = getCheckoutEventStep(state)

    // set the checkout step
    if (step && step !== previousStep) {
      dispatch({
        type: actions.SET_CHECKOUT_STEP,
        payload: step,
      })
    }

    // set the checkout step event
    if (eventStep && eventStep !== previousEventStep) {
      dispatch({
        type: actions.SET_CHECKOUT_EVENT_STEP,
        payload: eventStep,
      })

      // Send emarsys "go" command on every url in plan flow
      emarsysSend()
    }
  })
    .when(isCheckoutPage)
}

// -----------------------------------
// Watcher for setCheckoutStep
// -----------------------------------
export function onSetCheckoutStep ({ after }) {
  return after(actions.SET_CHECKOUT_STEP, async ({ dispatch, state }) => {
    const { checkout, auth, resolver } = state
    const accountInfo = checkout.get('account', Map())
    const checkoutStep = checkout.get('step')
    const authToken = auth.get('jwt')
    const planIsPreselected = checkout.get('checkoutPlanPreselected', false)
    const path = resolver.getIn(['data', 'path'])
    const singlePageCheckout = isSingleCheckoutPage(path)

    // check to see what step the user is on and if they have cart account info
    if (
      !authToken
        && accountInfo.size === 0
        && checkoutStep >= CHECKOUT_STEP_TWO
        && !planIsPreselected
        && !singlePageCheckout
    ) {
      dispatch({
        type: NAVIGATION_HISTORY_PUSH,
        payload: { url: URL_CART_ACCOUNT_CREATION_CREATE },
      })
    }
  })
    .when(isCheckoutPage)
}

// -----------------------------------
// Watcher for setCheckoutEventStep
// -----------------------------------
export function onSetCheckoutEventStep ({ after }) {
  return after(actions.SET_CHECKOUT_EVENT_STEP, async ({ action, state }) => {
    const { payload } = action
    const { plans } = state

    // set the checkout step event
    if (payload) {
      const eventData = {
        step: payload,
      }
      const selection = plans.get('selection', Map())

      if (selection.size > 0) {
        _set(eventData, 'selection', selection)
      }
    }
  })
    .when(isCheckoutPage)
}

// -----------------------------------
// Watcher for checking data "server side" on the Cart Access Info page
// -----------------------------------
export function onCheckoutCartAccessDeniedHydrationComplete ({ before }) {
  return before(SET_APP_BOOTSTRAP_PHASE, async ({ dispatch, state, action }) => {
    const { app, auth } = state
    const { payload } = action
    const { isComplete } = payload
    const previousBootstrapComplete = app.get('bootstrapComplete')
    const authToken = auth.get('jwt')

    // trigger the login modal for anonymous
    if (!authToken && isComplete && isComplete !== previousBootstrapComplete) {
      dispatch({
        type: SET_DIALOG_COMPONENT_NAME,
        payload: { name: TYPE_LOGIN },
      })
    }
  })
    .when(isCartAccessDeniedPage)
}

// -----------------------------------
// Watcher for componentDidMount/DidUpdate on the Cart Access Info page
// -----------------------------------
export function onCheckoutCartAccessDeniedMountAndUpdate ({ after }) {
  return after(SET_RESOLVER_DATA, async ({ dispatch, state }) => {
    const { auth } = state
    const authToken = auth.get('jwt')

    // trigger the login modal for anonymous
    if (!authToken) {
      dispatch({
        type: SET_DIALOG_COMPONENT_NAME,
        payload: { name: TYPE_LOGIN },
      })
    }
  })
    .when(isCartAccessDeniedPage)
}

// -----------------------------------
// Watcher for determining cart access when logged in
// -----------------------------------
export function onCheckoutAccessCheck ({ after }) {
  return after([
    SET_RESOLVER_DATA,
    SET_APP_BOOTSTRAP_PHASE,
    SET_PAYTRACK_DATA_LAST_TRANSACTION,
    SET_USER_ACCOUNT_DATA_BILLING_SUBSCRIPTIONS_WITH_DETAILS,
    SET_USER_DATA,
    SET_PLANS_DATA,
    SET_PLANS_SELECTION,
    SET_PLANS_SELECTION_ELIGIBILITY,
    SET_PLANS_LOCALIZED_PROCESSING,
    SET_USER_CHILD_ACCOUNT,
  ], async ({ dispatch, state }) => {
    const {
      user = Map(),
      auth = Map(),
      userAccount = Map(),
      paytrack = Map(),
      checkout = Map(),
      plans = Map(),
      resolver = Map(),
    } = state
    let entitled = user.getIn(['data', 'entitled'])
    const userProcessing = user.get('processing')
    const billingSubscriptionsProcessing = userAccount.get('billingSubscriptionsProcessing')
    const userBillingSubscriptions = userAccount.getIn(['details', 'data', 'billing', 'subscriptions'])
    const paytrackProcessing = paytrack.get('processing')
    const paytrackLastTransaction = paytrack.get('lastTransaction')
    const accessCheckDataReady = !billingSubscriptionsProcessing
      && !paytrackProcessing
      && userBillingSubscriptions && paytrackLastTransaction
      && !userProcessing
    const checkoutStep = checkout.get('step')
    const selectedPlan = plans.get('selection') || Map()
    const selectedPlanSku = selectedPlan.get('sku')
    const isGift = planIsGift(selectedPlan)
    const path = resolver.getIn(['data', 'path'])
    const singlePageCheckout = isSingleCheckoutPage(path)

    // we don't know if the user is entitled, so lets find out
    if (_isUndefined(entitled)) {
      try {
        const idExpires = auth.get('idExpires')
        const subscriptions = auth.get('subscriptions', List()).toJS()

        // set user processing
        dispatch({
          type: SET_USER_PROCESSING,
          payload: true,
        })

        entitled = await getUserEntitled(idExpires, subscriptions)

        dispatch({
          type: SET_USER_DATA_ENTITLED,
          payload: { value: entitled },
        })
      } catch (e) {
        dispatch({
          type: SET_USER_PROCESSING,
          payload: false,
        })
      }
    }

    // all the data is ready, so lets check the users access
    if (accessCheckDataReady) {
      const checkoutChangePlanAllowed = userCheckoutAccountChangePlanAllowed({
        userAccount,
      })
      const eligibilitySnapshot = selectedPlan.get('eligibility', Map()) || Map()
      const shouldFetchCheckoutEligibility = eligibilityCheckActive
        && planGraphQLActive
        && selectedPlanSku
        && !isGift
        && !checkoutChangePlanAllowed
        && eligibilitySnapshot.get('eligible') === undefined

      if (shouldFetchCheckoutEligibility) {
        const eligibilityPayload = await fetchPlanEligibility({
          sku: selectedPlanSku,
          page: BILLING_PLAN_GRID_LOCATION_CHECKOUT,
          jwt: auth.get('jwt'),
        })
        dispatch(setPlansSelectionEligibility({
          sku: selectedPlanSku,
          eligibility: eligibilityPayload || { eligible: true },
        }))
        return
      }

      const checkoutAllowed = userCheckoutAllowed({
        auth,
        user,
        userAccount,
        paytrack,
      }, entitled)
      const checkoutAllowedNoPlanSelected = checkoutAllowed
        && checkoutStep >= CHECKOUT_STEP_THREE
        && (!selectedPlanSku || isGift)
      const eligibilityForAccess = selectedPlan.get('eligibility', Map()) || Map()
      const eligibleForAccess = eligibilityForAccess.get('eligible')

      if (checkoutChangePlanAllowed && selectedPlanSku) {
        // if the user comes into the checkout flow with a plan selected,
        // and is an existing user that already has an active plan/subscription,
        // send them into the Account Change Plan flow
        dispatch({
          type: NAVIGATION_HISTORY_PUSH,
          payload: { url: `${URL_ACCOUNT_CHANGE_PLAN}?sku=${selectedPlanSku}` },
        })
      } else if (eligibilityCheckActive && selectedPlan.size > 0 && eligibleForAccess === false
        // USER_REQUIRED is only meaningful for anonymous users; after login, selection
        // may still carry it until GET_PLANS_BY_SKU refetch — do not show a stale modal.
        && eligibilityForAccess.get('errorCode') !== USER_REQUIRED) {
        dispatch(renderModal(TYPE_MODAL_PLAN_ACCESS, {
          hideDismiss: true,
          eligibility: eligibilityForAccess,
          page: BILLING_PLAN_GRID_LOCATION_CHECKOUT,
        }))
      } else if (eligibilityCheckActive && !checkoutAllowed && !selectedPlan.size) {
        // if the user is not allowed to checkout, send them to the cart access denied page
        dispatch({
          type: NAVIGATION_HISTORY_PUSH,
          payload: { url: URL_CART_ACCESS_DENIED },
        })
        dispatch(removeInterstitial())
      } else if (!eligibilityCheckActive && !checkoutAllowed) {
        // if the user is not allowed to checkout, send them to the cart access denied page
        dispatch({
          type: NAVIGATION_HISTORY_PUSH,
          payload: { url: URL_CART_ACCESS_DENIED },
        })
        dispatch(removeInterstitial())
      } else if (checkoutAllowedNoPlanSelected && !singlePageCheckout) {
        dispatch({
          type: NAVIGATION_HISTORY_PUSH,
          payload: { url: URL_PLAN_SELECTION_PLANS },
        })
      }
    }

    // kickoff check for myqee email
    const email = auth.get('email')
    const userAcquisitions = user.get('userAcquisitions')
    if (email && !userAcquisitions) dispatch(getUserEmailAvailability(email))
  })
    .when(isAuthenticatedCheckout)
}

// -----------------------------------
// Watcher for determining cart access when anonymous
// -----------------------------------
export function onAnonymousCheckoutAccessCheck ({ after }) {
  return after([
    SET_RESOLVER_DATA,
    SET_APP_BOOTSTRAP_PHASE,
  ], async ({ dispatch, state }) => {
    const { checkout, plans } = state
    const checkoutStep = checkout.get('step')
    const selectedPlan = plans.get('selection', Map())
    // if checkout step should have a plan selection and doesn't
    // or if the plan that was selected is a gift, redirect
    const noPlanSelected = checkoutStep >= CHECKOUT_STEP_TWO
        && (!selectedPlan || planIsGift(selectedPlan))
    const noAccountInfo = checkout.get('account', Map()).size === 0 && checkoutStep >= CHECKOUT_STEP_TWO

    if (noAccountInfo && noPlanSelected) {
      // if the user is not allowed to checkout, send them back to cart account creation
      dispatch({
        type: NAVIGATION_HISTORY_PUSH,
        payload: { url: URL_ACCOUNT_CREATION },
      })
    }
  })
    .when(isAnonymousCheckout)
}

export function watchSetPlansData ({ after }) {
  return after([SET_PLANS_DATA, SET_PLANS_SELECTION], async ({ dispatch, state }) => {
    const {
      plans, userAccount, user, auth,
    } = state
    const selectedPlan = plans.get('selection') || Map()
    const selectedSku = selectedPlan.get('sku')
    const currentPlan = selectedSku ? (plans.getIn(['data', 'plans']) || Map()).find((p) => p.get('sku') === selectedSku) || Map() : Map()
    const currencyIso = getAuthIsLoggedIn(auth) && currentPlan.size > 0 ? currentPlan.get('currencyIso') : null
    const userLangauge = getPrimary(user.getIn(['data', 'language'], EN))
    const plansLanguage = plans.getIn(['data', 'language'])
    const latamPricing = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'latamPricing'])
    const currency = latamPricing ? LTM : currencyIso

    // If the user changes their language while in the checkout flow with a plan already selected
    // then set their selection again so that we pick up the proper translations
    if (selectedPlan.size > 0
      && !selectedPlan.equals(currentPlan)
      && !planIsGift(selectedPlan)) {
      const language = user.getIn(['data', 'language'])

      try {
        dispatch(setPlansLocalizedSelection({ plan: currentPlan, language, currency }))
      } catch (error) {
        // Do Nothing for now
      }
    }

    // if the user's language doesn't match the plans language,
    // then refetch the plans with the correct language
    if (selectedPlan.size > 0 && userLangauge !== plansLanguage) {
      try {
        dispatch(getPlansData({ language: userLangauge, currency }))
      } catch (error) {
        // Do Nothing for now
      }
    }
  })
    .when(isCheckoutFlow)
}

/**
 * Watcher for the account create data being set.
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness after function
 */
export function watchAccountCreateData ({ after }) {
  return after(actions.SET_CHECKOUT_ACCOUNT_CREATE_DATA, async ({ dispatch, state, action }) => {
    const {
      auth,
      plans,
      user,
      checkout,
      inboundTracking,
      resolver,
    } = state
    const { payload: data } = action
    const email = _get(data, 'email')
    const password = _get(data, 'password')
    const firstName = _get(data, 'firstName')
    const lastName = _get(data, 'lastName')
    const emailOptIn = _get(data, 'emailOptIn')
    const language = user.getIn(['data', 'language'], List([EN])).toJS()
    const selectedPlan = plans.get('selection')
    const creationSource = checkout.get('creationSource')
    const path = resolver.getIn(['data', 'path'])
    const singlePageCheckout = isSingleCheckoutPage(path)

    dispatch(actions.setCheckoutUserData(data))
    // If the user is logged in, redirect them to the plan selection page or account create
    // Otherwise, create a new user account for them
    if (getAuthIsLoggedIn(auth) && !singlePageCheckout) {
      if (selectedPlan && !planIsGift(selectedPlan)) {
        dispatch({
          type: NAVIGATION_HISTORY_PUSH,
          payload: { url: URL_CART_BILLING },
        })
      } else {
        dispatch({
          type: NAVIGATION_HISTORY_PUSH,
          payload: { url: URL_PLAN_SELECTION },
        })
        // GA4 event
        dispatch(setEventDefault(ACCOUNT_CONFIRM_DETAILS_GA4_EVENT))
        // Optimizely event
        dispatch(sendOptimizelyFeatureEvent({ eventName: 'account_confirm_details' }))
      }
    } else {
      dispatch({
        type: SET_USER_CREATE_PROCESSING,
        payload: true,
      })

      const newUser = await userCreate({
        language,
        email,
        password,
        ...(firstName && { firstName }),
        ...(lastName && { lastName }),
        emailOptIn,
        creationSource,
        inboundTracking,
      })

      dispatch({
        type: SET_USER_CREATE_DATA,
        payload: { data: newUser, processing: false },
      })
    }
  })
    .when(isAccountCreatePage)
}

/**
 * Watcher for the new user create data being set.
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness after function
 */
export function watchSetUserCreateData ({ after }) {
  return after(SET_USER_CREATE_DATA, async ({ dispatch, state, action }) => {
    const {
      user,
      page,
      checkout,
      resolver,
      staticText,
      inboundTracking,
    } = state
    const { payload } = action
    const newUserSuccess = user.getIn(['newUser', 'data', 'success'])
    const loginErrorMessage = staticText.getIn(['data', 'cartAccountCreatePageV2', 'data', 'userLoginError'])
    const { appCountry } = config
    const email = checkout.getIn(['account', 'email'])
    const firstName = checkout.getIn(['account', 'firstName'])
    const lastName = checkout.getIn(['account', 'lastName'])
    const emailOptIn = checkout.getIn(['account', 'emailOptIn'])
    const uid = user.getIn(['newUser', 'data', 'uid'])
    const userId = parseInt(uid, 10) || undefined
    const username = user.getIn(['newUser', 'data', 'username'])
    const language = getPrimary(user.getIn(['data', 'language'], List([EN])))
    const locale = page.get('locale')
    const today = formatDateTime(undefined, locale, dateFormatString)
    const utmCampaign = inboundTracking.getIn(['data', 'utm_campaign'], '')
    const country = user.getIn(['data', 'requestCountry'], appCountry)
    const xff = user.get('xff') || user.getIn(['data', 'xff'])
    const requestStatus = user.getIn(['newUser', 'data', 'requestStatus'])
    const errorDetail = user.getIn(['newUser', 'data', 'errorDetail'])
    const errorMeta = user.getIn(['newUser', 'data', 'errorMeta'])
    const errorString = user.getIn(['newUser', 'data', 'errorString'])
    const userCreateMessages = user.getIn(['newUser', 'data', 'messages'], List()).join([' | '])
    const userCreateCodes = user.getIn(['newUser', 'data', 'codes'], List()).join([' | '])
    const loginSuccess = _get(payload, ['data', 'auth', 'success'], false)
    const statusCode = _get(payload, ['data', 'requestStatus'], 500)
    const codes = _get(payload, ['data', 'codes'], [])
    const creationSource = checkout.get('creationSource')
    const configuration = getConfig()
    const showGranularEmailPreferences = !!_get(configuration, ['features', 'granularEmailPreferences'])
    const singlePageCheckout = isSingleCheckoutPage(resolver.getIn(['data', 'path']))

    if (newUserSuccess) {
      dispatch({
        type: actions.SET_CHECKOUT_REACTIVATION,
        payload: false,
      })

      // fire event sign_up
      // GA4 event
      dispatch(setEventDefault(
        SIGN_UP_GA4_EVENT.mergeDeep({
          user_id: userId,
          membership_status: USER_ACCOUNT_UNENTITLED,
          ui_location: singlePageCheckout ? 'simplified checkout' : 'precursor checkout',
        }),
      ))

      // optimizely event
      dispatch(sendOptimizelyFeatureEvent({ eventName: 'sign_up' }))

      // send facebook lead event
      dispatch({
        type: SET_EVENT_LEAD,
        payload: email,
      })

      // send data to Emarsys
      const fields = {
        email,
        country,
        first_name: firstName,
        last_name: lastName,
        registration_language: language,
        drupal_user_id: uid,
        entitled: false,
        creation_source: creationSource || USER_CREATION_SOURCE_ZUORA,
        cart_start_date: today,
        campaign_acq: utmCampaign,
      }
      postEmailCapture({
        email,
        optin: emailOptIn,
        ...(showGranularEmailPreferences && {
          [EMAIL_PREFERENCE_NEWSLETTER]: emailOptIn,
          [EMAIL_PREFERENCE_MARKETPLACE]: emailOptIn,
          [EMAIL_PREFERENCE_GAIA_SPHERE]: emailOptIn,
          [EMAIL_PREFERENCE_FREE_ONLINE]: emailOptIn,
        }),
        fields,
        source: '',
        inboundTracking,
      })

      // Use the auth data that was returned from the account create to log the user in
      dispatch({ type: AUTH_LOGIN })

      if (loginSuccess) {
        dispatch(setAuthPersistentData(_get(payload, ['data', 'auth'], Map())))
        dispatch(setAuthLoginSuccess(true))
      }

      // if login fails show the login modal
      if (!loginSuccess) {
        dispatch(setAuthLoginFailed(codes, statusCode))
        dispatch({ type: AUTH_ERROR })
        dispatch({
          type: SET_DIALOG_COMPONENT_NAME,
          payload: { name: TYPE_LOGIN },
        })
        dispatch({
          type: SET_DIALOG_OPTIONS,
          payload: { customMessage: loginErrorMessage },
        })
      }
    }

    const dataNewRelic = {
      type: DEVICE,
      language,
      country,
      utmCampaign,
      utmString: inboundTracking.getIn(['data', 'strings', 'utm'], ''),
      rfd: inboundTracking.getIn(['data', 'rfd'], ''),
      source: inboundTracking.getIn(['data', 'source'], ''),
      username,
      userCreated: newUserSuccess,
      userLogin: newUserSuccess ? loginSuccess : null,
      requestStatus,
      errorMeta,
      errorDetail,
      errorString,
      userCreateMessages,
      userCreateCodes,
      anonymousUuid: user.getIn(['data', 'anonymousUuid']),
      xff,
    }

    addNewRelicAction('CheckoutUserCreate', dataNewRelic)
  })
    .when(isAccountCreatePage)
}

/**
 * Watcher for login success on the cart account create page.
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness after function
 */
export function watchAccountCreateLoginSuccess ({ after }) {
  return after(SET_AUTH_LOGIN_SUCCESS, async ({ state, dispatch }) => {
    const {
      auth,
      inboundTracking,
      user,
      plans,
      checkout,
      remoteLoginCode,
      resolver,
    } = state
    const selectedPlan = plans.get('selection') || Map()
    const selectedPlanSku = selectedPlan.get('sku')
    const termsChecked = checkout.getIn(['account', 'terms'])
    const remoteCode = remoteLoginCode.get('code')
    const path = resolver.getIn(['data', 'path'])
    const singlePageCheckout = isSingleCheckoutPage(path)
    const userLanguage = getPrimary(user.getIn(['data', 'language'], List([EN])))
    const authToken = auth.get('jwt')

    // If the user has a selected plan, refetch plan-by-SKU after login (JWT-aware).
    // Checkout plan eligibility is loaded only in onCheckoutAccessCheck (with
    // checkoutChangePlanAllowed gating), not here — userAccount can still be
    // settling on this tick and would wrongly allow a checkout eligibility query
    // that completes after redirect to change-plan.
    if (selectedPlanSku) {
      const { data, error } = await apolloClient.query({
        query: GET_PLANS_BY_SKU,
        variables: {
          language: userLanguage,
          skus: [selectedPlanSku],
        },
        fetchPolicy: APOLLO_CLIENT_FETCH_POLICY_NETWORK_ONLY,
        errorPolicy: APOLLO_CLIENT_ERROR_POLICY_ALL,
        context: {
          jwt: authToken,
        },
      }) || { data: { billingProviderProductList: { billingProviderProducts: [] } } }

      if (!error && _size(_get(data, ['billingProviderProductList', 'billingProviderProducts'], [])) > 0) {
        const formattedPlanData = fromJS(formatBillingPlans(data)) || List()
        dispatch(setPlansSelection(formattedPlanData.get(0) || Map()))
      }
    }

    dispatch(removeInterstitial())

    if (isRemoteAccountCreatePage({ state }) && remoteCode) {
      // approve remote login code
      await dispatch(getRemoteLoginCodeApproval({ auth, remoteLoginCode: remoteCode }))
    } else if (selectedPlanSku && termsChecked && !singlePageCheckout) {
      // send the user to billing after login
      dispatch({
        type: NAVIGATION_HISTORY_PUSH,
        payload: { url: URL_CART_BILLING },
      })
    } else if (!selectedPlanSku && termsChecked && !singlePageCheckout) {
      // send the user to plan selection after login
      dispatch({
        type: NAVIGATION_HISTORY_PUSH,
        payload: { url: URL_PLAN_SELECTION },
      })
    }
    // Setup anything related to feature tracking now that we have auth
    await onAuthLoginFeatureTracking({
      auth: auth.get('jwt'),
      user,
      setFeatureTrackingDataPersistent,
    })

    // set navTourTooltips status to not show nav v2 tooltips for a new user
    const userFeaturesUpdate = {
      navTourTooltips: NAV_TOUR_STATUS_HAS_SEEN,
    }
    // set announcementModal status to not show announcement modal for a new user
    if (config.features.announcementModal.enabled) {
      userFeaturesUpdate.announcementModal = true
    }
    dispatch(setFeatureTrackingDataPersistent({
      data: Map(userFeaturesUpdate),
      auth,
    }))

    // set the content impression
    if (
      inboundTracking.getIn(['data', 'ci_id'])
      || inboundTracking.getIn(['data', 'ci_type'])
    ) {
      setContentImpression({
        auth: auth.get('jwt'),
        timestamp: new Date(),
        contentId: inboundTracking.getIn(['data', 'ci_id']),
        contentType: inboundTracking.getIn(['data', 'ci_type']),
      })
    }
  })
    .when(isAccountCreatePage)
}

/**
 * Watcher for login dialog so we can reset the options.
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness after function
 */
export function watchAccountCreateLoginDialog ({ after }) {
  return after(SET_DIALOG_COMPONENT_NAME, async ({ dispatch, action }) => {
    const { payload } = action
    const { name } = payload

    if (name === TYPE_LOGIN) {
      dispatch({
        type: SET_DIALOG_OPTIONS,
        payload: {},
      })
    }
  })
    .when(({ state }) => {
      const { resolver } = state
      const path = resolver.getIn(['data', 'path'])
      return isAccountCreatePage({ state })
        && !isSingleCheckoutPage(path)
        && !isCartAccountCreationCreate(path)
    })
}

/**
 * Watcher for a plan being selected.
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness after function
 */
export function watchSetPlansSelection ({ after }) {
  return after(
    [SET_PLANS_SELECTION, actions.SET_CHECKOUT_ACCOUNT_CREATE_DATA],
    async ({ state, dispatch }) => {
      const {
        checkout, plans, user, inboundTracking, resolver,
      } = state
      const email = checkout.getIn(['account', 'email']) || user.getIn(['data', 'mail'])
      const emailOptIn = checkout.getIn(['account', 'emailOptIn'])
      const selectedPlan = plans.get('selection')
      const singlePageCheckout = isSingleCheckoutPage(resolver.getIn(['data', 'path']))

      // send the GA event when a plan is selected
      if (selectedPlan) {
        // GA4 event
        dispatch(setEventDefault(
          BEGIN_CHECKOUT_GA4_EVENT.mergeDeep(
            buildCheckoutEcommerceObject(selectedPlan),
            { ui_location: singlePageCheckout ? 'simplified checkout' : 'precursor checkout' },
          ),
        ))
        // optimizely event
        dispatch(sendOptimizelyFeatureEvent({
          eventName: 'begin_checkout',
          tags: {
            SKU: selectedPlan.get('sku'),
            plan_type: selectedPlan.get('type'),
          },
        }))
      }

      // if a plan is selected, send info to Emarsys
      if (selectedPlan && email) {
        postEmailCapture({
          email,
          optin: emailOptIn,
          source: '',
          inboundTracking,
        })
      }
    },
  ).when(({ state, prevState }) => {
    const { plans = Map() } = state
    const { plans: prevPlans = Map() } = prevState
    const selectedPlanId = plans.getIn(['selection', 'id']) || null
    const prevSelectedPlanId = prevPlans.getIn(['selection', 'id']) || null

    // Return true if the selected plan exists and has changed
    return selectedPlanId && (selectedPlanId !== prevSelectedPlanId)
  })
}

/**
 * Watcher for credit card and PayPal checkout.
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness after function
 */
export function watchCheckoutPaymentType ({ after }) {
  return after(
    [
      SET_PAYMENT_DATA,
    ],
    async ({ state, dispatch }) => {
      const {
        checkout,
        auth,
        user,
        userAccount,
        page,
        plans,
        gift,
        inboundTracking,
        payment,
        velocityCheck,
      } = state
      const userInfo = checkout.get('account', Map())
      const emailOptIn = userInfo.get('emailOptIn')
      // If the user is logged in, get their currency iso from their account
      // Otherwise get the currency iso from the plans
      const currencyIso = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'currencyIso'])
        || plans.getIn(['selection', 'currencyIso'])
        || gift.getIn(['details', 'planCurrency'])
        || USD
      const isGiftSubscriptionActive = userAccount.getIn(['details', 'data', 'gift', 'currentGift', 'status']) === GIFT_SUBSCRIPTION_STATE.ACTIVE
      const mostRecentEntitlement = selectMostRecentEligibleEntitlement(state)
      const userEntitlementsEndDate = mostRecentEntitlement ? mostRecentEntitlement.get('end') : undefined
      const datesForMax = [getUnixTimestamp(userAccount.getIn(['details', 'data', 'gift', 'paidThroughDate'])), userEntitlementsEndDate].filter((x) => x != null && x !== '')
      const giftEndDate = datesForMax.length ? _max(datesForMax) : undefined
      const entitlementEndDate = isGiftSubscriptionActive ? giftEndDate : userEntitlementsEndDate
      const entitlementEnd = (entitlementEndDate != null && entitlementEndDate !== '') ? parseInt(entitlementEndDate, 10) * 1000 : 0
      const locale = page.get('locale')
      const formattedEndDate = formatDateTime(entitlementEnd, locale, dateFormatString)
      const productRatePlanId = plans.getIn(['selection', 'id'])
      const planSku = plans.getIn(['selection', 'sku'])
      const startDateOverrideInfo = shouldOverrideStartDate(state) ? { formattedEndDate } : null
      const reactivation = checkout.get('reactivation')
      const paymentSuccess = payment.getIn(['data', 'payments', 'success'])
      const paymentResultCode = payment.getIn(['data', 'payments', 'data', 'resultCode'])
      const paymentIsAuthorized = paymentResultCode === ADYEN_PAYMENT_RESPONSE_CODE_AUTHORIZED
      const paymentAuthorizationUuid = payment.getIn(['data', 'payments', 'authorization', 'uuid'])
      const velocityCheckToken = velocityCheck.getIn(['data', 'velocityCheck', 'token'])
      const paymentType = payment.getIn(['data', 'payments', 'data', 'paymentMethod', 'type'], '')
      const paymentAction = payment.getIn(['data', 'payments', 'data', 'action'], '')
      const baseNewRelicData = getBaseNewRelicData(state)
      const refusalReason = payment.getIn(['data', 'payments', 'data', 'refusalReason'], '')

      // if the Adyen payment wasn't successful then bail
      if (!paymentSuccess) {
        addNewRelicAction(
          'CheckoutFlowPaymentFailure',
          {
            ...baseNewRelicData,
            paymentType,
            paymentTokenResultCode: paymentResultCode,
            paymentTokenSuccess: paymentSuccess,
            paymentAction,
            refusalReason,
            planSku,
          },
        )

        return
      }

      const paymentInfo = {
        currencyIso,
        country: payment.getIn(['data', 'payments', 'billingAddress', 'country']) || payment.getIn(['data', 'billingInfo', 'billingAddress', 'country']),
        postalCode: payment.getIn(['data', 'payments', 'billingAddress', 'postalCode']) || payment.getIn(['data', 'billingInfo', 'billingAddress', 'postalCode']),
        productRatePlanId,
        planSku,
        adyen: {
          shopperReference: payment.getIn(['data', 'payments', 'data', 'additionalData', 'recurring.shopperReference']) || user.getIn(['data', 'uuid']) || auth.get('uuid'),
          ...(paymentIsAuthorized) && { recurringDetailReference: payment.getIn(['data', 'payments', 'data', 'additionalData', 'recurring.recurringDetailReference']) },
          cardSummary: payment.getIn(['data', 'payments', 'data', 'additionalData', 'cardSummary']),
          fundingSource: payment.getIn(['data', 'payments', 'data', 'additionalData', 'fundingSource']),
        },
      }

      // Paypal payment
      if (paymentType === ADYEN_PAYMENT_TYPE_PAYPAL) {
        // GA4 event
        dispatch(setEventDefault(PAYPAL_POPUP_OPENED_GA4_EVENT))
      }

      if (window.scrollTo) {
        requestAnimationFrame(() => window.scrollTo(0, 0))
      }

      const orderV2 = await dispatch(
        actions.processCheckoutOrder({
          auth,
          paymentInfo,
          tracking: inboundTracking,
          startDateOverrideInfo,
          reactivation,
          emailOptIn,
          fbEventId: paymentAuthorizationUuid,
          velocityCheckToken,
        }),
      )

      addNewRelicAction(
        'CheckoutFlowPaymentSuccess',
        {
          ...baseNewRelicData,
          paymentType,
          paymentTokenResultCode: paymentResultCode,
          paymentTokenSuccess: paymentSuccess,
          paymentAction,
          planSku,
          checkoutSuccess: _get(orderV2, 'success'),
          checkoutId: _get(orderV2, 'checkoutId'),
          statusCode: _get(orderV2, 'status'),
        },
      )
    },
  )
    .when(isCheckoutPage)
}

/**
 * Watcher for checkout order data, redirecting the user to the cart confirmation page.
 * This is used for both CC and PayPal orders.
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness after function
 */
export function watchSetCheckoutOrderData ({ after }) {
  return after(
    actions.SET_CHECKOUT_ORDER_DATA,
    async (
      {
        state,
        dispatch,
      },
    ) => {
      const {
        checkout,
        auth,
        inboundTracking,
        payment,
        plans,
        resolver,
      } = state
      const currentPath = resolver.get('path')

      if (checkout.getIn(['orderData', 'success'])) {
        const authorizationUuid = payment.getIn(['data', 'payments', 'authorization', 'uuid'])
        const transactionId = checkout.getIn(['orderData', 'billing', 'orderNumber']) || checkout.getIn(['orderData', 'billingResponse', 'orderNumber'])
        const selectedPlan = plans.get('selection', Map()) || Map()
        const currencyIso = selectedPlan.get('currencyIso')
        const value = formatCheckoutOrderMarketingValue(selectedPlan)

        // send authorization data when checkout is complete
        if (authorizationUuid) {
          updateAdyenAuthorization({
            auth,
            uuid: authorizationUuid,
            billingAccountCreated: true,
          })
        }

        // server side purchase event
        if (getConfig().features.events.server) {
          const fbp = getCookie('_fbp')
          const fbc = getCookie('_fbc')

          dispatch({
            type: CREATE_SERVER_EVENT,
            payload: {
              event: SERVER_EVENT_PURCHASE,
              data: {
                eventName: FACEBOOK_EVENT_NAME_PURCHASE,
                actionSource: FACEBOOK_EVENT_ACTION_SOURCE,
                eventSourceUrl: `${URL_GAIA_PROD}${URL_CART_CONFIRMATION}`,
                eventId: authorizationUuid,
                ...(fbp) && { fbp },
                ...(fbc) && { fbc },
                data: {
                  currency: currencyIso,
                  price: value,
                  orderId: transactionId,
                },
              },
            },
          })
        }

        const dataNewRelic = {
          type: DEVICE,
          ch: inboundTracking.getIn(['data', 'ch'], ''),
          ci_id: inboundTracking.getIn(['data', 'ci_id'], null),
          ci_type: inboundTracking.getIn(['data', 'ci_type'], ''),
          rfd: inboundTracking.getIn(['data', 'rfd'], ''),
          source: inboundTracking.getIn(['data', 'source'], ''),
          utmString: inboundTracking.getIn(['data', 'strings', 'utm'], ''),
          utm_campaign: inboundTracking.getIn(['data', 'utm_campaign'], ''),
          utm_content: inboundTracking.getIn(['data', 'utm_content'], ''),
          utm_medium: inboundTracking.getIn(['data', 'utm_medium'], ''),
          utm_source: inboundTracking.getIn(['data', 'utm_source'], ''),
          utm_term: inboundTracking.getIn(['data', 'utm_term'], ''),
          username: checkout.getIn(['orderData', 'newUsername']) || auth.get('username'),
          orderNumber: checkout.getIn(['orderData', 'billing', 'orderNumber'], '') || checkout.getIn(['orderData', 'billingResponse', 'orderNumber']),
        }

        addNewRelicAction('SignupSuccess', dataNewRelic)

        // Dispatch checkout flow
        dispatch({
          type: actions.SET_CHECKOUT_FLOW,
          payload: currentPath,
        })

        dispatch({
          type: NAVIGATION_HISTORY_PUSH,
          payload: { url: URL_CART_CONFIRMATION },
        })

        // clear the gaia plan selection from session storage
        clearSessionStorage(SESSION_STORAGE_GAIA_PLAN_SELECTION)

        if (window.scrollTo) {
          requestAnimationFrame(() => window.scrollTo(0, 0))
        }
      }
    },
  )
}

/**
 * Watcher for order errors.
 * This is used for both CC and PayPal orders.
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness after function
 */
export function watchSetCheckoutOrderError ({ after }) {
  return after(actions.SET_CHECKOUT_ORDER_ERROR, async ({ state, dispatch }) => {
    const {
      user = Map(),
      auth = Map(),
      resolver = Map(),
      checkout = Map(),
      app = Map(),
    } = state
    const fingerprintjsProVersion = app.get('fingerprintjsProVersion')

    if (!fingerprintjsProVersion) {
      throw new Error('The fingerprintjsProVersion property is required on app state')
    }

    if (velocityCheckActive) {
      const velocityPage = getVelocityCheckActionLocation({ auth, checkout, resolver })
      const userUuid = user.getIn(['data', 'uuid'])

      // since the order failed, call the velocity check again
      const fp = await FingerprintJS.load({
        apiKey: fingerprintJsApiKey,
        endpoint: fingerprintJsSubdomain,
        scriptUrlPattern: [
          // This endpoint will be used primarily
          // cache busting the fingerprintjs script by adding a value to "fpjs"
          // just increment the value to bust the cache
          `/fingerprintjs/v3/${fingerprintJsApiKey}/loader_v${fingerprintjsProVersion}.js?fpjs=1`,
          // The default endpoint will be used if the primary fails
          FingerprintJS.defaultScriptUrlPattern,
        ],
      })
      const fpResult = await fp.get({
        timeout: 10000,
      })
      const fingerprintId = _get(fpResult, 'visitorId')
      const requestId = _get(fpResult, 'requestId')

      dispatch({
        type: SET_VELOCITY_CHECK_PROCESSING,
        payload: true,
      })

      // if order is not successful, then get a new set of velocity data
      const velocity = await checkVelocity(
        {
          userInfoUuid: userUuid,
          fingerprintId,
          requestId,
          page: velocityPage,
          auth,
        },
      )

      dispatch({
        type: SET_VELOCITY_CHECK_DATA,
        payload: { data: velocity, processing: false },
      })
    }
  })
}

/**
 * Watcher for client side and server side navigation to the cart confirmation page.
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness after function
 */
export function watchCartConfirmationPage ({ after }) {
  return after(
    [
      SET_RESOLVER_DATA,
      SET_APP_BOOTSTRAP_PHASE,
    ],
    async ({
      state, prevState, dispatch, action,
    }) => {
      const {
        app,
        auth,
        inboundTracking,
        checkout,
      } = state
      const { app: prevApp } = prevState
      const bootstrapComplete = app.get('bootstrapComplete')
      const prevBootstrapComplete = prevApp.get('bootstrapComplete')
      const loggedIn = getAuthIsLoggedIn(auth)
      const orderData = checkout.get('orderData', Map())

      // if the user is coming directly to this url, or if they refresh the page
      // we will have no redux data, therefore we will be unable to render the page
      // properly, so send them to the homepage or plan selection
      if (action.type === SET_APP_BOOTSTRAP_PHASE && bootstrapComplete !== prevBootstrapComplete) {
        dispatch({
          type: NAVIGATION_HISTORY_PUSH,
          payload: { url: loggedIn ? URL_HOME : URL_ACCOUNT_CREATION },
        })
        return
      }

      // if the user is redirected from the payment page to the confirmation page
      if (action.type === SET_RESOLVER_DATA && orderData.size > 0) {
        let authResult = {}

        try {
          await retry(async () => {
            authResult = await dispatch(doAuthRenew(auth, false, true)) || {}
            const authSubscriptions = _get(authResult, 'subscriptions', [])

            // any user going through checkout should have an active subscription/entitlement
            // if this is empty, then there is probably a DB replication lag, so try again
            // until we get a subscription/entitlement
            if (_isEmpty(authSubscriptions)) {
              throw new Error('Checkout Auth Renew - User has no subscriptions/entitlements')
            }

            return authResult
          }, {
            max: 8,
            backoffBase: 100,
            backoffExponent: 1.2,
            timeout: 30000,
          })
        } catch (e) {
          // do nothing for now
        }

        dispatch(setMessageBoxVisible(false))
        onAuthRenewSuccess({
          auth: authResult,
          inboundTracking,
        }, dispatch)
      }
    },
  )
    .when(isCartConfirmationPage)
}

/**
 * Watcher for login success on the cart confirmation page.
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness after function
 */
export function watchCartConfirmationLoginSuccess ({ after }) {
  return after(SET_AUTH_LOGIN_SUCCESS, async ({ state }) => {
    const { auth, inboundTracking, user } = state
    // Setup anything related to feature tracking now that we have auth
    await onAuthLoginFeatureTracking({
      auth: auth.get('jwt'),
      user,
      setFeatureTrackingDataPersistent,
    })

    // set the content impression
    if (
      inboundTracking.getIn(['data', 'ci_id'])
      || inboundTracking.getIn(['data', 'ci_type'])
    ) {
      setContentImpression({
        auth: auth.get('jwt'),
        timestamp: new Date(),
        contentId: inboundTracking.getIn(['data', 'ci_id']),
        contentType: inboundTracking.getIn(['data', 'ci_type']),
      })
    }
  })
    .when(isCartConfirmationPage)
}

/**
 * Watcher for login failed on the cart confirmation page.
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness after function
 */
export function watchCartConfirmationLoginFailed ({ after }) {
  return after(SET_AUTH_LOGIN_FAILED, async ({ dispatch }) => {
    dispatch({
      type: SET_DIALOG_COMPONENT_NAME,
      payload: { name: TYPE_LOGIN },
    })
  })
    .when(isCartConfirmationPage)
}

/**
 * Watcher for getting the user account billing subscription details on the confirmation page.
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness after function
 */
export function watchUserAccountDataBillingSubscriptions ({ after }) {
  return after(
    SET_USER_ACCOUNT_DATA_BILLING_SUBSCRIPTIONS_WITH_DETAILS,
    async ({ state, dispatch }) => {
      const {
        userAccount,
        checkout,
        user,
        plans,
        page,
        payment,
        eventTracking,
        inboundTracking,
      } = state
      const email = user.getIn(['data', 'mail'])
      const emailOptIn = checkout.getIn(['account', 'emailOptIn'])
      const uuid = user.getIn(['data', 'uuid'])
      const trialPeriod = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'plan', 'inTrialSegment'])
      const authorizationUuid = payment.getIn(['data', 'payments', 'authorization', 'uuid'])
      const locale = page.get('locale')
      const today = formatDateTime(undefined, locale, dateFormatString)
      const mostRecentAmount = _toNumber(parseFloat(userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'plan', 'charges', 0, 'price'], 0)).toFixed(2))
      const currencyIso = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'currencyIso'])
      const paidThroughDate = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'paidThroughDate'])
      const fullPlanPrice = List.isList(plans.getIn(['selection', 'costs'])) ? _toNumber(parseFloat(plans.getIn(['selection', 'costs']).last()).toFixed(2)) : 0
      const isReactivation = checkout.get('reactivation')
      const lastPurchasedEvent = eventTracking.getIn(['lastPurchasedEvent'], false)
      const selectedPlan = plans.get('selection')
      const transactionId = checkout.getIn(['orderData', 'billing', 'orderNumber']) || checkout.getIn(['orderData', 'billingResponse', 'orderNumber'])
      const planSku = plans.getIn(['selection', 'sku'], '')
      const singlePageCheckout = !!checkout.get('singlePageCheckoutStep')
      const paymentBinNumber = payment.getIn(['data', 'payments', 'data', 'additionalData', 'cardBin'])
      const isCashAppBin = paymentBinNumber !== null && paymentBinNumber !== undefined
        && _isArray(cashAppBinNumbers)
        && _includes(_map(cashAppBinNumbers, _toString), _toString(paymentBinNumber))

      // Add new purchase events, if we haven't sent one already
      if (!lastPurchasedEvent) {
        // GA4 events
        dispatch(setEventDefault(
          PURCHASE_GA4_EVENT.mergeDeep(
            {
              gaia_transaction_id: transactionId,
              cash_app_bin: isCashAppBin,
              gaia_event_id: authorizationUuid,
            },
            buildCheckoutEcommerceObject(selectedPlan, transactionId),
            { ui_location: singlePageCheckout ? 'simplified checkout' : 'precursor checkout' },
          ),
        ))
        dispatch(setEventDefault(
          getPurchasedPlanEventData(planSku).mergeDeep({
            ui_location: singlePageCheckout ? 'simplified checkout' : 'precursor checkout',
            gaia_event_id: authorizationUuid,
          }),
        ))
        // optimizely event
        dispatch(sendOptimizelyFeatureEvent({
          eventName: 'purchase',
          tags: {
            SKU: planSku,
            plan_type: selectedPlan.get('type'),
          },
        }))
      }

      const fields = {
        entitled: true,
        trial_period: trialPeriod,
        plan_start_date: today,
        subscription_start_date: today,
        ...(!isReactivation) && { cart_complete_date: today },
        ...(isReactivation) && { cart_reactivation_date: today },
        user_billing_status: 'active', // @TODO: update this for adyen (active/pending)
        in_member_base: !trialPeriod || isReactivation,
        payment_provider: PAYMENT_PROVIDER_NAME_ZUORA,
        uuid,
        most_recent_amt_paid_in_currency: mostRecentAmount,
        currency: currencyIso,
        paid_through_date: paidThroughDate,
        full_plan_price: fullPlanPrice,
        winback: isReactivation,
        next_bill_amount: fullPlanPrice,
      }
      postEmailCapture({
        email,
        optin: emailOptIn,
        fields,
        source: '',
        inboundTracking,
      })
    },
  )
    .when(isCartConfirmationPage)
}

/**
 * Watcher for checking if the user has completed checkout.
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness after function
 */
export function watchCheckoutComplete ({ after }) {
  return after(
    [
      SET_RESOLVER_DATA,
      SET_APP_BOOTSTRAP_PHASE,
      SET_USER_DATA,
      SET_AUTH_LOGIN_SUCCESS,
    ],
    async ({
      state, dispatch,
    }) => {
      const {
        user,
        auth,
        checkout,
        resolver,
      } = state
      const checkoutComplete = user.getIn(['data', 'checkout_complete'])
      const loggedIn = getAuthIsLoggedIn(auth)
      const uid = _parseInt(user.getIn(['data', 'uid']))
      const accountOwnerUid = _parseInt(user.getIn(['data', 'account_owner_uid']))
      const isPrimaryAccount = uid === accountOwnerUid
      const checkoutOrderSuccess = checkout.getIn(['orderData', 'success'])
      const hasAmbassadorRole = auth.get('roleIds', List()).includes(ROLE_ID_AMBASSADOR)

      // single page checkout toggle
      const path = resolver.getIn(['data', 'path'])
      const singlePageCheckout = isSingleCheckoutPage(path)
      const isTermsPage = isPolicy(path)

      // disable cart abandoned popup on these pages for the purchase-only-user flow
      const isPurchaseOnlyUserFlowPage = purchaseOnlyUserFlowActive
        && (isPlaylistPage(path) || isVideoOrSeries(path))

      // if we have successfully checked out, the cart abandon overlay should not show
      if (checkoutOrderSuccess) {
        return
      }

      if (loggedIn
        && isPrimaryAccount
        && !checkoutComplete
        && !hasAmbassadorRole
        && !singlePageCheckout
        && !isTermsPage
        && !isPurchaseOnlyUserFlowPage
      ) {
        dispatch(renderModal(TYPE_CART_ABANDON, {
          hideDismiss: true,
        }))
      }
    },
  )
    .when(renderCartAbandon)
}

/**
 * Watcher for determining if the user is new (not a reactivation), or winback (reactivation).
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness after function
 */
export function watchCheckoutReactivation ({ after }) {
  return after(
    [
      SET_APP_BOOTSTRAP_PHASE,
      SET_USER_DATA,
      SET_AUTH_LOGIN_SUCCESS,
    ],
    async ({
      state, dispatch,
    }) => {
      const {
        user,
      } = state
      const checkoutComplete = user.getIn(['data', 'checkout_complete'])

      dispatch({
        type: actions.SET_CHECKOUT_REACTIVATION,
        payload: checkoutComplete,
      })
    },
  )
    .when(({ state }) => {
      const { auth, resolver } = state
      const path = resolver.getIn(['data', 'path'])
      return getAuthIsLoggedIn(auth) && !isCartConfirmation(path)
    })
}

/**
 * Set checkout polling watcher that will fetch checkout order status + data
 * @param {Object} param0 The parameters
 * @param {Function} param0.before The witness before function
 */
export function watchSetCheckoutOrderStatus ({ after } = {}) {
  return after(actions.SET_CHECKOUT_ORDER_STATUS, async ({ state, action, dispatch }) => {
    const { auth, checkout } = state
    const { payload } = action
    const { id, attempts } = payload
    const reactivation = checkout.get('reactivation')
    const checkoutId = id

    // if we have reached the limit, bail
    if (attempts >= CHECKOUT_ASYNC_MAX_ATTEMPTS) {
      return dispatch(actions.setCheckoutOrderError(CHECKOUT_ORDER_ERROR_TYPE_UNKNOWN))
    }

    const checkoutOrderData = await getCheckoutOrderData({ checkoutId, auth })

    if (_get(checkoutOrderData, 'done')) {
      if (_get(checkoutOrderData, 'success')) {
        dispatch(
          actions.setCheckoutOrderData({ ...checkoutOrderData, isReactivation: reactivation }),
        )
      } else {
        const orderErrorCode = _get(checkoutOrderData, 'errorCode') ? _get(checkoutOrderData, 'errorCode') : CHECKOUT_ORDER_ERROR_TYPE_UNKNOWN
        dispatch(actions.setCheckoutOrderError(orderErrorCode))
      }
    } else {
      dispatch(actions.setCheckoutOrderStatus(checkoutId, attempts + 1))
    }

    return null
  })
    .debounce(CHECKOUT_ASYNC_DELAY_MILLISECONDS)
}

/**
 * Set checkout polling watcher that will fetch checkout order status + data
 * @param {Object} param0 The parameters
 * @param {Function} param0.before The witness before function
 */
export function watchCheckoutInitiated ({ after }) {
  return after([
    SET_RESOLVER_DATA,
  ], async ({
    dispatch,
  }) => {
    dispatch(actions.setCheckoutInitiated(true))
  })
    .when(({ state }) => {
      const { resolver, checkout } = state
      const path = resolver.get('path')
      const checkoutInitiated = checkout.get('checkoutInitiated')
      const singlePageCheckout = isSingleCheckoutPage(path)

      if (
        (path === URL_PLAN_SELECTION
        || path === URL_PLAN_SELECTION_PLANS
        || path === URL_ACCOUNT_CREATION
        || path === URL_CART_ACCOUNT_CREATION_CREATE
        || path === URL_CART_BILLING
        || path === URL_CART_BILLING_PAYMENT
        || singlePageCheckout)
        && !checkoutInitiated
      ) {
        return true
      }

      return false
    })
}

/**
 * Watcher for payment info page - adyen ready
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness after function
 */
export function watchCheckoutPaymentAdyenReady ({ after }) {
  return after(
    [SET_ADYEN_DROP_IN_READY],
    async ({ state, dispatch }) => {
      const { resolver } = state
      const singlePageCheckout = isSingleCheckoutPage(resolver.getIn(['data', 'path']))

      dispatch(setEventDefault(PAYMENT_INFO_PAGE_GA4_EVENT.mergeDeep({
        ui_location: singlePageCheckout ? 'simplified checkout' : 'precursor checkout',
      })))
      // optimizely event
      dispatch(sendOptimizelyFeatureEvent({
        eventName: 'payment_info_page',
      }))
    },
  ).when(isCartPaymentPage)
}

/**
 * Watcher for setting the checkout plan selection in session storage
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness after function
 */
export function watchSetCheckoutPlanSelection ({ after }) {
  return after(
    SET_PLANS_SELECTION,
    async ({ action }) => {
      const { payload } = action
      const { data } = payload
      const payloadPlan = Map.isMap(data) ? data : Map()

      // if the payload plan is valid, set it in session storage
      if (payloadPlan.size > 0) {
        setSessionStorage(SESSION_STORAGE_GAIA_PLAN_SELECTION, payloadPlan.toJS())
      }
    },
  )
    .when(isGraphQLCheckoutFlow)
}

/**
 * Watcher for clearing the checkout plan selection in session storage
 * if the user is redirected to the cart access denied page
 * if they get sent to the cart access denied page they can't purchase a plan
 *
 * @param {Object} param0 The parameters
 * @param {Function} param0.after The witness after function
 */
export function watchCartAccessDeniedPage ({ after }) {
  return after(SET_RESOLVER_DATA, async () => {
    const gaiaPlanSelection = getSessionStorage(SESSION_STORAGE_GAIA_PLAN_SELECTION)

    if (gaiaPlanSelection) {
      clearSessionStorage(SESSION_STORAGE_GAIA_PLAN_SELECTION)
    }
  })
    .when(isCartAccessDeniedPage)
}
